import { render, staticRenderFns } from "./HowTo.vue?vue&type=template&id=473360ac&scoped=true"
import script from "./HowTo.vue?vue&type=script&lang=js"
export * from "./HowTo.vue?vue&type=script&lang=js"
import style0 from "./HowTo.vue?vue&type=style&index=0&id=473360ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473360ac",
  null
  
)

export default component.exports